import React from "react";
//import { Context } from "../App";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { greys, blue, boxShadow } from "../../utils/styles";
import { motion } from "framer-motion";

const FooterWrapper = styled(motion.div)`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
  z-index: 5;
  transition: transform 1s;
  bottom: 0;
  box-shadow: ${boxShadow};
  background: white;
  position: fixed;
  .navDiv {
    width: 100%;
    text-align: center;
    color: white;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  }
  .navLink {
    font-size: 14px;
    text-decoration: none;
    font-weight: 500;
    color: ${greys[300]};
  }
  .navLinkActive {
    margin-top: 10px;
    &::after {
      content: " ";
      display: block;
      position: relative;
      height: 4px;
      border-radius: 5px;
      background: ${blue[100]};
      margin-top: 5px;
    }
  }
  .breaks {
    width: 1px;
    height: 18px;
    background-color: ${greys[100]};
  }
`;

const breaks = <div className="breaks"></div>;

const NavLinkC = ({ to, children }) => (
  <NavLink
    exact
    to={to}
    className="navLink"
    activeClassName={"navLinkActive"}
    isActive={(_, location) => location.pathname.includes(to)}
    // onClick={() => setCurrRoute(to)}
  >
    {children}
  </NavLink>
);

const Footer = ({ renderFooterColor, info }) => {
  console.log(info);
  //const { setCurrRoute } = useContext(Context);
  return (
    <FooterWrapper renderFooterColor={renderFooterColor}>
      <div className="navDiv">
        <NavLinkC to={"/home"}>Home</NavLinkC>
        {breaks}
        <NavLinkC to={"/whymomentum"}>Why Momentum</NavLinkC>
        {breaks}
        <NavLinkC to={"/solarplusstorage"}>Solar + Storage</NavLinkC>
        {breaks}
        <NavLinkC to={"/whysolar"}>Why Go Solar</NavLinkC>
        {breaks}
        <NavLinkC to={"/accolades"}>Accolades</NavLinkC>
        {breaks}
        <NavLinkC to={"/referral"}>Referral</NavLinkC>
        {breaks}
        <NavLinkC to={"/ourwork"}>Our Work</NavLinkC>
        {breaks}
        <NavLinkC to={"/thanks"}>Thank You</NavLinkC>
      </div>
    </FooterWrapper>
  );
};
export default Footer;
